(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    const productImageModalTransition = (update) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (document.startViewTransition && !reduceMotion) {
      document.startViewTransition(update);
      return;
    }
    update();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-image-modal-id]');
    if (trigger) {
      const container = trigger.closest('.product-images-container');
      const dialog = container && container.querySelector('[data-product-image-modal]');
      const viewport = dialog && dialog.querySelector('[data-product-image-modal-viewport]');
      const selectedItem = dialog && dialog.querySelector(
        `[data-product-image-modal-item="${trigger.dataset.productImageModalId}"]`
      );
      if (!dialog || !viewport) return;

      dialog.querySelectorAll('.product-image-modal__image').forEach((image) => {
        image.loading = 'eager';
      });
      dialog.productImageModalTrigger = trigger;
      productImageModalTransition(() => {
        dialog.showModal();
        viewport.scrollTop = selectedItem ? selectedItem.offsetTop : 0;
      });
      return;
    }

    const closeButton = event.target.closest('[data-product-image-modal-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-product-image-modal]');
      if (dialog) productImageModalTransition(() => dialog.close());
      return;
    }

    if (event.target.matches('[data-product-image-modal]')) {
      productImageModalTransition(() => event.target.close());
    }
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches('[data-product-image-modal]')) return;

    if (event.target.productImageModalTrigger) {
      event.target.productImageModalTrigger.focus();
      event.target.productImageModalTrigger = null;
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
